import { useContext } from 'react';
import { AdContext } from '../providers/AdProvider';

export const useAd = () => {
  return useContext(AdContext);
};
